import axios from "axios";
import Token from "../jwt/Token.js";

import Config from "../../service/Auth/Config.js";

export default class Storage extends Token {
    /*BAIXANDO UM ARQUIVO*/
    download(hashKey) {
        return axios({
            method: "get",
            //url: this.api_storage + "file/download/" + hashKey,
            url: new Config()._api_storage + "file/public/" + hashKey,
            withCredentials: true,
            headers: {
                //Authorization: "Bearer " + this.token(),
            },
            responseType: "blob",
        });
    }
    /*UPDANDO UM ARQUIVO PARA DENTRO DE UM DIRETORIO*/
    upload(arquivo, folderId) {
        //console.log(this.api_storage);

        const formData = new FormData();
        formData.append("file", arquivo);

        return axios({
            method: "post",
            //url: this.api_storage + "file/upload?folder=" + folderId,
            url: new Config()._api_storage + "file/upload?folder=" + folderId,
            withCredentials: true,
            data: formData,
            headers: {
                //Authorization: "Bearer " + this.token(),
                //"Content-Type": "multipart/form-data",
            },
        });
    }
    /*ATUALIZANDO UM ARQUIVO DENTRO DE UM DIRETORIO
    PELO HASH DO ARQUIVO*/
    update(hashKey, arquivo) {
        return axios({
            method: "put",
            url: new Config()._api_storage + "file/" + hashKey,
            withCredentials: true,
            data: { file: arquivo },
            headers: {
                //Authorization: "Bearer " + this.token(),
                "Content-Type": "multipart/form-data",
            },
        });
    }
    /*REMOVENDO ARQUIVO DE DENTRO DE UM DIRETORIO PELO HASH*/
    remove(hashKey) {
        return axios({
            method: "delete",
            url: new Config()._api_storage + "file/" + hashKey,
            withCredentials: true,
            headers: {
                //'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    /*VIZUALIZANDO UM ARQUIVO OUTRA ABA*/
    previewFileToPage(hashKey) {
        window.open(
            `${new Config()._api_storage}file/preview/${hashKey}`,
            "_blank",
        );
    }
    /*VIZUALIZANDO UM ARQUIVO DE ACORDO COM A URL. ESPECIFICO PARA PDF, PNG, JPG E JPEG*/
    previewImg(hashKey) {
        if (hashKey === null || hashKey === "") {
            return;
        } else {
            return this.checkProviderImg(hashKey);
        }
    }

    checkProviderImg(param) {
        /* SE O PROVEDOR DA IMAGEM FOR O FIREBASE */
        if (param.includes("firebase")) {
            return param;
            /* SE O PROVEDOR DA IMAGEM FOR API DE STORAGE */
        } else {
            return `${new Config()._api_storage}file/public/${param}`;
        }
    }

    searchDir() {
        let directors = {}; // Alterado para objeto e definido como let para reatribuição
        //console.log(process.env.VUE_APP_ENV);
        switch (process.env.VUE_APP_ENV) {
            case "development":
                //console.log("DESENVOLVIMENTO");
                directors = {
                    arquivos: {
                        key:
                            "F-167cad025c-3a6b-4ff8-9c1c-677e614d89c7" /** USA DAS CREDENCIAIS DE DEV */,
                    },
                };
                break;
            case "production":
                //console.log("Produção");
                directors = {
                    arquivos: {
                        key: "F-5168ea2ad-2f74-4690-bcf8-25d471bc4cb3",
                    },
                };
                break;
            case "staging":
                //console.log("Homologação");
                directors = {
                    arquivos: {
                        key: "",
                    },
                };
                break;
            case "training":
                //console.log("Treinamento");
                directors = {
                    arquivos: {
                        key: "",
                    },
                };
                break;
            default:
                console.log("Ambiente não definido");
                break;
        }
        return directors;
    }
}
